import { axios } from "../axios.instance";

export type RequestEmailVerificationResponse = {
  waitMs: number;
  otpSentAt: string;
};

export const requestEmailVerification = async (): Promise<RequestEmailVerificationResponse> => {
  const { data } = await axios.post("auth/request-email-verification");
  return data;
};

export type VerifyEmailRequest = {
  code: string;
};

export type VerifyEmailResponse = void;

export const verifyEmail = async (body: VerifyEmailRequest): Promise<VerifyEmailResponse> => {
  const { data } = await axios.post("auth/verify-email", body);
  return data;
};
